import React = require('react');

import { beaconComponentRegistryEntry, getUserAccountSettingsURL } from '~src/beacon/BeaconComponentRegistryFunctions';
import { DeepLink } from '~src/beacon/deepLink/DeepLink';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';

import { Messages } from '../../codegen/Localize';
import { UserSettingsStyle } from '../styles/UserSettingsStyle';
import { ToastAutoDismiss } from './ToastAutoDismissSetting';


const DEEPLINK_ID = 'accessibility-preferences';

export type AccessibilitySettingsProps = {
  userHasNoSiteId: boolean;
}

export function AccessibilitySettings(props: AccessibilitySettingsProps): JSX.Element {
  return (
    <>
      <h2 className={UserSettingsStyle.titleText}>{Messages.userSettings_Accessibility_Header()}</h2>
      <DeepLink deepLinkId={DEEPLINK_ID}>
        <table>
          <tbody>
              <tr>
                <td className={UserSettingsStyle.tbody} colSpan={2}>
                  <ToastAutoDismiss {...props} />
                </td>
              </tr>
          </tbody>
        </table>
      </DeepLink>
    </>
  );
}

export const AccessibilityPreferencesSettingBeaconConfig = beaconComponentRegistryEntry({
  command: () =>  Messages.userSettings_Accessibility_Header(),
  deeplinkId: DEEPLINK_ID,
  url: (props) => getUserAccountSettingsURL(props.sessionInfo),
  tags:  () => { return [Messages.userSettings_Accessibility_Header()]; },
  isAdmin: false,
  isVisible: () => FeatureFlags.toastAutoDismissSettingEnabled,
});